import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {
  faDownload = faDownload
  faCircleCheck = faCircleCheck 

  status!:string
  serviceNumber!:string
  constructor(
    private route:ActivatedRoute,
    private router: Router,
    private storageService: StorageService
  ) {
    this.status = this.route.snapshot.params['status']
    this.serviceNumber = this.route.snapshot.params['serviceNumber']
   }

  ngOnInit(): void {
  }
  stepOn(){
    const token = this.storageService.getData('encodedToken');
    this.router.navigate(['/'], {queryParams: { q: token }})

  }

}
